
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="grid">
    <b-link>
      <b-row>
        <b-col
          cols="12"
          xl="4"
          lg="6"
          v-for="(work, index) in works"
          :key="index"
        >
          <work-card :work="work"></work-card>
        </b-col>
      </b-row>
    </b-link>
  </div>
</template>
<script>
import WorkCard from "./WorkCard.vue";
export default {
  name: "WorkGrid",
  props: ["works"],
  components: { WorkCard },
  computed: {
  },
};
</script>
